module.exports = __webpack_public_path__ + "static/img/bg-home.e1484f66.jpg";